/* eslint-disable max-len */
import React, { Fragment } from 'react';
import { push } from 'react-router-redux';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { getNextOnboardingRoute } from '../accountCompletionValidators';
import VerificationStatus from './VerificationStatus';
import { CONTACT_EMAIL_DEFAULT } from '../../../config';

const IndividualForm = reduxForm({
  form: 'verificationForm',
  enableReinitialize: true,
})((props) => {
  const {
    handleSubmit,
    update,
    dispatch,
    accreditationStatus,
    accreditationType,
    kycStatus,
  } = props;

  const linkAndUpdate = (values) => {
    let earlyIqUrl;
    switch (accreditationType) {
      case 'INDIVIDUAL':
        earlyIqUrl =
          'https://entoro.investready.com/';
        break;
      case 'INSTITUTION':
        earlyIqUrl =
          'https://entoro.investready.com/';
        break;
      case 'ACCREDITED_OPTION':
        earlyIqUrl =
          'https://entoro.investready.com/';
        break;
      default:
        break;
    }

    window.open(earlyIqUrl, '_blank');
    update(values, false); // Do not redirect to next onboarding route
  };

  return (
    <div className='w-clearfix w-form'>
      <form className='w-clearfix'>
        <VerificationStatus
          accreditationStatus={accreditationStatus}
          kycStatus={kycStatus}
          accreditationType={accreditationType}
        />
        {accreditationStatus !== 'EXEMPTED' ? (
          <Fragment>
            <div className='option-container'>
              <div className='text-accred-options'>
                For certain structured offerings, you must be an Accredited
                Investor or Institution to invest. If this applies to you,
                please visit Invest Ready (a third party accredited investor
                verification service) below. Please note that this is not
                required of every Investor so kindly disregard if unapplicable.
              </div>
              <button
                href='#'
                className='button-2 no-align w-button'
                onClick={handleSubmit((values) => linkAndUpdate(values))}
              >
                Visit Invest Ready
              </button>
            </div>
            <div className='grey-regular max-width'>
              Note: If you already have a 3rd party accreditation verification
              please email document(s) to{' '}
              <a
                href={`mailto:${CONTACT_EMAIL_DEFAULT}?subject=third-pardy%20accreditation%20help`}
                className='text-link'
              >
                {CONTACT_EMAIL_DEFAULT}
              </a>
            </div>
          </Fragment>
        ) : null}
        <div className='full-line bottom' />
        <button
          className='button-2 w-button'
          onClick={() =>
            dispatch(push(getNextOnboardingRoute(props) || '/dashboard'))
          }
        >
          Save & Continue
        </button>
      </form>
    </div>
  );
});

const mapStateToProps = ({ investorUser, router }) => ({
  investorUser,
  accreditationType: investorUser.accreditationType,
  location: router.location,
  accreditationStatus: investorUser.accreditationStatus,
  kycStatus: investorUser.kycStatus,
});

export default connect(mapStateToProps)(IndividualForm);



// WEBPACK FOOTER //
// ./src/components/Account/InvestorVerification/VerificationForm.js